import React from "react";
import classes from "./FileRow.css"


const fileRow = (props) => {

  // Only display element if show prop is true
  if (typeof(props.show) === "boolean") {
    if (props.show === false) {
      return null
    }
  }

  const outerClasses = [classes.rowContainer];
  if (props.firstRow === true) {
    outerClasses.push(classes.isFirstRow);
  }

  // Generate unique ID to support multiple FileRow components on the same page
  const inputId = props.inputId || "fileInput";

  // Determine what to show - selected file indicator or default body text
  const hasSelectedFile = props.selectedFileName && props.selectedFileName.length > 0;
  const displayText = hasSelectedFile ? props.selectedFileName : props.body;
  const labelClasses = hasSelectedFile 
    ? `${classes.fileLabel} ${classes.fileSelected}` 
    : classes.fileLabel;

  return (
    <div className={outerClasses.join(" ")}>
      <p className={classes.title}>{props.title}</p>
      <input
        type="file"
        id={inputId}
        accept={props.extension}
        className={classes.fileInput}
        onChange={props.onClick}/>
      <label htmlFor={inputId} className={labelClasses}>
        {displayText}
      </label>
    </div>
  );
};


export default fileRow;
